import { steps } from "@/data/content";

export default function HowItWorks() {
  return (
    <section id="how" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="max-w-2xl">
          <span className="eyebrow">How Aura Works</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">
            How Aura creates an event
          </h2>
          <p className="mt-4 font-body text-[var(--aura-charcoal-2)]">
            A clear, human process from track selection to post-event momentum.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-5 relative">
          {steps.map((s, i) => (
            <div
              key={s.n}
              className="relative p-7 rounded-2xl bg-white border border-black/5"
            >
              <div className="font-display text-6xl leading-none text-[var(--aura-teal)]/15">
                {s.n}
              </div>
              <h3 className="mt-3 font-display text-xl leading-snug">
                {s.title}
              </h3>
              <p className="mt-2 font-body text-sm text-[var(--aura-charcoal-2)] leading-relaxed">
                {s.body}
              </p>
              {i < steps.length - 1 && (
                <span className="hidden lg:block absolute top-8 -right-3 w-6 h-px bg-[var(--aura-teal)]/30" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
